<template>
  <div>
    <custom-button @click="handleShowLog">Show Log</custom-button>
    <div class="modal fade" id="modalLog" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">{{ productName }} Log</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <table
              class="table table-sm table-bordered table-striped table-responsive-sm"
            >
              <thead class="">
                <tr>
                  <th>When</th>
                  <th>What</th>
                  <th>Who</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingLog === false && dataLog.length === 0">
                  <td colspan="3" class="text-center">Data Not Available</td>
                </tr>
                <tr v-else-if="loadingLog === true">
                  <td colspan="3" class="text-center">
                    <img src="~@/assets/images/load-button.gif" />
                  </td>
                </tr>
                <tr
                  v-for="(data, index) in dataLog"
                  v-else
                  :key="`log-${index}`"
                >
                  <td>{{ data.time }}</td>
                  <td v-html="data.text"></td>
                  <td>{{ data.ids }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomButton } from "../../Button";

export default {
  name: "Logs",
  components: { CustomButton },
  props: {
    productName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dataLog: [],
      loadingLog: false,
    };
  },
  computed: {
    catalogId() {
      return this.$route.params.id;
    },
  },
  methods: {
    handleShowLog() {
      this.dataLog = [];
      this.loadingLog = true;
      $("#modalLog").modal("show");
      this.fetchLog();
    },
    fetchLog() {
      this.loadingLog = true;
      this.$http
        .get(process.env.LOG_URL + "/catalog_product/" + this.catalogId, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.loadingLog = false;
          if (response.data.status === 200) {
            this.dataLog = response.data.content;
          }
        })
        .catch((error) => {
          this.loadingLog = false;
          console.log(error);
        });
    },
  },
  mounted() {
    this.fetchLog();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Catalog/Components/Logs.vue